// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
export default {
  "AE":{
     "national":"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}"
  },
  "AT":{
     "national":"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}"
  },
  "AU":{
     "national":"1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}"
  },
  "BE":{
     "national":"4\\d{8}|[1-9]\\d{7}"
  },
  "BG": {
   "national": "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}"
  },
  "CA":{
     "national":"(?:[2-8]\\d|90)\\d{8}"
  },
  "CH":{
     "national":"8\\d{11}|[2-9]\\d{8}"
  },
  "CN":{
     "national":"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}"
  },
  "CZ":{
     "national":"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}"
  },
  "DE":{
     "national":"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}"
  },
  "DK":{
     "national":"[2-9]\\d{7}"
  },
  "ES":{
     "national":"[5-9]\\d{8}"
  },
  "EE": { 
     "national": "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}" 
  },
  "FI":{
     "national":"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}"
  },
  "FR":{
     "national":"[1-9]\\d{8}"
  },
  "GB":{
     "national":"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}"
  },
  "GR":{
     "national":"5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}"
  },
  "HK":{
     "national":"8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}"
  },
  "HR":{
     "national":"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}"
  },
  "IE":{
     "national":"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}"
  },
  "IL":{
     "national":"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}"
  },
  "IN":{
     "national":"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}"
  },
  "IS":{
     "national":"(?:38\\d|[4-9])\\d{6}"
  },
  "IT":{
     "national":"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}"
  },
  "JO":{
     "national":"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}"
  },
  "JP":{
     "national":"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}"
  },
  "KR":{
     "national":"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}"
  },
  "LT": {
   "national": "(?:[3469]\\d|52|[78]0)\\d{6}"
  },
  "LU":{
     "national":"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}"
  },
  "LV": {
   "national": "(?:[268]\\d|90)\\d{6}"
  },
  "MO":{
     "national":"(?:28|[68]\\d)\\d{6}"
  },
  "MX":{
     "national":"(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}"
  },
  "NL":{
     "national":"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}"
  },
  "NO":{
     "national":"(?:0|[2-9]\\d{3})\\d{4}"
  },
  "NZ":{
     "national":"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}"
  },
  "PL":{
     "national":"6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?"
  },
  "PR":{
     "national":"(?:[589]\\d\\d|787)\\d{7}"
  },
  "PT":{
     "national":"(?:[26-9]\\d|30)\\d{7}"
  },
  "SE":{
     "national":"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}"
  },
  "SI":{ 
     "national": "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}" 
  },
  "SG":{
     "national":"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}"
  },
  "SK":{ 
     "national": "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}" 
  },
  "TR": { 
     "national": "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}"
  },
  "TW":{
     "national":"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}"
  },
  "US":{
     "national":"[2-9]\\d{9}"
  },
  "ZA":{
     "national":"[1-79]\\d{8}|8\\d{4,9}"
  },
  "RO":{
     "national":"(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}"
  },
  "HU":{
     "national":"[235-7]\\d{8}|[1-9]\\d{7}"
  }
}